import React, { useMemo } from 'react';
import { isDev, isLocal, isStg } from '@/constant';
import Head from 'next/head';

type PageHeadProps = {
  headTitle?: string;
};

const PageHead = ({ headTitle = 'F&F Portal' }: PageHeadProps) => {
  // 탭을 여러 개 띄웠을 때 구분하기 위함
  const envLabel = useMemo(() => {
    if (isLocal) return '🏠';
    if (isDev) return '🛠';
    if (isStg) return '🔭';
    return '';
  }, []);

  return (
    <Head>
      <title>{envLabel + headTitle}</title>
    </Head>
  );
};

export default PageHead;
